import {Trans} from 'react-i18next'

import {Alert, Box, Button, Typography, useTheme} from '@mui/material'

import useChangeLanguage from '@progyny/components/Navigation/useChangeLanguage'

const PrivacyAlertBox = () => {
  const theme = useTheme()
  const {changeLanguage} = useChangeLanguage()

  return (
    <Box
      marginTop={theme.spacing(4)}
      marginBottom={theme.spacing(6)}
      maxWidth={786}
      sx={{display: 'inline-block'}}
    >
      <Alert
        severity={'info'}
        sx={{
          display: 'flex',
          paddingX: theme.spacing(3),
          paddingY: theme.spacing(2),
          borderRadius: 2,
        }}
      >
        <Typography variant={'h6'}>
          🔔{' '}
          <Trans i18nKey='create_account_privacy_alert_box_translation_disclaimer' />
        </Typography>
        <Typography variant={'caption'}>
          <Trans i18nKey='create_account_privacy_alert_box_this_translated_version_of_privacy' />
          <Trans i18nKey='create_account_privacy_alert_box_it_is_not_legally_binding' />
          <Trans i18nKey='budget_partner_agreement_pa_form_please_note_that_you_may' />
        </Typography>

        <Button
          variant='text'
          onClick={async () => {
            await changeLanguage('en')
          }}
        >
          <Trans i18nKey='create_account_privacy_alert_box_show_original_version' />
        </Button>
      </Alert>
    </Box>
  )
}

export default PrivacyAlertBox
